import { TranslationKey } from "../../../../../types/i18next";

export const getJobseekerInviteButtonText = (
  applied: boolean,
  inviteSent: boolean
): TranslationKey => {
  if (applied) return 'matches.button.applied';
  if (inviteSent) return 'matches.button.invite';
  return 'matches.button.send';
};
